import { ReactElement } from "react";
import { AiOutlineBook, AiOutlineHome } from "react-icons/ai";
import { GiMeditation } from "react-icons/gi";
import { LuCircle } from "react-icons/lu";
import { TbAugmentedReality } from "react-icons/tb";
import { PiFileTextBold } from "react-icons/pi";
import { FiSliders, FiUsers } from "react-icons/fi";
import { BsBuilding, BsBuildings, BsCollection, BsList, BsPeople } from 'react-icons/bs';
import { PiGearBold } from 'react-icons/pi';
import { GiGears } from 'react-icons/gi';
import { GoOrganization } from "react-icons/go";
import { MdAccountBalance, MdAccountTree, MdAttachMoney, MdCategory, MdEmojiPeople, MdFactCheck, MdHistory, MdInventory, MdInventory2, MdManageAccounts, MdMemory, MdOutlineAccountBalanceWallet, MdOutlineAccountCircle, MdOutlineAccountTree, MdOutlineAssignment, MdOutlineCategory, MdOutlineFavoriteBorder, MdOutlineLibraryBooks, MdOutlineManageAccounts, MdOutlineMenuBook, MdOutlineReceiptLong, MdOutlineSupervisorAccount, MdOutlineVolunteerActivism, MdPeopleAlt, MdSyncAlt, MdVolunteerActivism } from 'react-icons/md';

export type SidebarItem = {
  title: string;
  path: string;
  icon: ReactElement;
  cName: string;
  roles?: string[];
  dynamicSubNav?: boolean;
};

export type SidebarGroup = {
  title: string;
  path: string;
  icon: ReactElement;
  cName: string;
  roles?: string[];
  subNav?: SidebarItem[];
};

type SidebarElement = SidebarItem | SidebarGroup;


export const buildSidebarData = (): SidebarElement[] => [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <AiOutlineHome />,
    cName: "nav-text",
    // roles: ["Admin", "User"],
    roles: ["Admin"],

  },

  {
    title: "Account Ledger",
    path: "/account-ledger",
    icon: <AiOutlineBook />,
    cName: "nav-text",
    roles: ["Admin"],
  },

  {
    title: "Common",
    path: "#",
    icon: <FiUsers />,
    cName: "nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Country",
        path: "/common/country",
        icon: <BsPeople />,
        cName: "sub-nav-text",
        roles: ["admin"]

      },
      {
        title: "State",
        path: "/common/state",
        icon: <BsBuildings />,
        cName: "sub-nav-text",
      },
    ]
  },
  {
    title: "User Masters",
    path: "#",
    icon: <FiUsers />,
    cName: "nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Organization Master",
        path: "/user-master/organization-master",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "User Master",
        path: "/user-master/user",
        icon: <BsPeople />,
        cName: "sub-nav-text",
        roles: ["admin"]

      },
      {
        title: "User Subscriber",
        path: "/user-master/user-subscriber",
        icon: <BsBuildings />,
        cName: "sub-nav-text",
      },
      {
        title: "User Group",
        path: "/user-master/user-group",
        icon: <BsCollection />,
        cName: "sub-nav-text",
      },
    ]
  },
  {
    title: "DataSource Mangement",
    path: "#",
    icon: <BsList />,
    cName: "sub-nav-text",
    // roles: ["admin", "user"],
    roles: ["Admin"],

    subNav: [
      // {
      //   title: "Organization Master",
      //   path: "/data-source/organization-master",
      //   icon: <GoOrganization />,
      //   cName: "sub-nav-text",
      //   roles: ["admin"]
      // },
      {
        title: "Value Chain Category",
        path: "/data-source/value-chain-category",
        icon: <GiGears />,
        cName: "sub-nav-text",
        roles: ["admin"]

      },
      {
        title: "Value Chain",
        path: "/data-source/value-chain",
        icon: <PiGearBold />,
        cName: "sub-nav-text",
        roles: ["admin"]

      },
      {
        title: "Responsibility Group",
        path: "/data-source/responsibility-group",
        icon: <BsPeople />,
        cName: "sub-nav-text",
        roles: ["admin"]

      },
      {
        title: "Responsibility Center",
        path: "/data-source/responsibility-center",
        icon: <BsBuilding />,
        cName: "sub-nav-text",
        roles: ["admin"]

      },
      {
        title: "Agent Master",
        path: "/data-source/agent-master",
        icon: <MdManageAccounts />,
        cName: "sub-nav-text",
        roles: ["admin"]

      },
      {
        title: "Token Mechanism Master",
        path: "/data-source/token-mechanism-master",
        icon: <MdManageAccounts />,
        cName: "sub-nav-text",
        roles: ["admin"],
      }
    ],
  },
  {
    title: "Member Masters",
    path: "#",
    icon: <MdOutlineSupervisorAccount />,
    cName: "nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Member Master",
        path: "/member-masters/member-master",
        icon: <MdOutlineAccountCircle />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "Member Category Master",
        path: "/member-masters/member-category",
        icon: <MdAccountTree />,
        cName: "sub-nav-text",
        roles: ["admin"]

      },
    ]
  },
  {
    title: "Accounting Masters",
    path: "#",
    icon: <MdOutlineSupervisorAccount />,
    cName: "nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Account Master",
        path: "/accounting-masters/accounting-master",
        icon: <MdOutlineManageAccounts />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "Account Category Master",
        path: "/accounting-masters/accounting-category",
        icon: <MdOutlineAccountTree />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "Account Type Master",
        path: "/accounting-masters/accounting-type",
        icon: <MdOutlineCategory />,
        cName: "sub-nav-text",
        roles: ["admin"]
      }
    ]
  },

  {
    title: "Scenario & Scripture Masters",
    path: "/scenario-scripture-masters",
    icon: <MdOutlineLibraryBooks />,
    cName: "nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Scenario Master",
        path: "/scenario-scripture-masters/scenario-master",
        icon: <MdOutlineAssignment />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "Scriptural Reference Master",
        path: "/scenario-scripture-masters/scripture-master",
        icon: <MdOutlineMenuBook />,
        cName: "sub-nav-text",
        roles: ["admin"]
      }
    ]
  },
  {
    title: "Voucher & Transaction",
    path: "/voucher-transaction",
    icon: <MdOutlineReceiptLong />,
    cName: "nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Voucher Type Master (Finance)",
        path: "/voucher-transaction/voucher-type-master-finance",
        icon: <MdOutlineAccountBalanceWallet />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "Voucher Type Master (Karma)",
        path: "/voucher-transaction/voucher-type-master-karma",
        icon: <MdOutlineFavoriteBorder />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "Voucher Finance",
        path: "/voucher-transaction/voucher-finance",
        icon: <MdAttachMoney />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "Voucher Karma",
        path: "/voucher-transaction/voucher-karma",
        icon: <MdEmojiPeople />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "Voucher Participant",
        path: "/voucher-transaction/voucher-participant",
        icon: <MdPeopleAlt />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "Party Category Master",
        path: "/voucher-transaction/party-category-master",
        icon: <MdCategory />,
        cName: "sub-nav-text",
        roles: ["admin"]
      }
    ]
  },


  {
    title: "Opening Balances",
    path: "/opening-balances",
    icon: <MdAccountBalance />,
    cName: "nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Opening Balance (Finance)",
        path: "/opening-balances/opening-balance-finance",
        icon: <MdAttachMoney />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "Opening Balance (Karma)",
        path: "/opening-balances/opening-balance-karma",
        icon: <MdVolunteerActivism />,
        cName: "sub-nav-text",
        roles: ["admin"]
      }
    ]
  },
  {
    title: "Inventory",
    path: "/inventory",
    icon: <MdInventory2 />,
    cName: "nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Inventory Category Master",
        path: "/inventory/inventory-category-master",
        icon: <MdCategory />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "Inventory Item Master",
        path: "/inventory/inventory-item-master",
        icon: <MdInventory />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "Inventory Opening Balance",
        path: "/inventory/inventory-opening-balance",
        icon: <MdAccountBalance />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "Inventory Transactions",
        path: "/inventory/inventory-transactions",
        icon: <MdSyncAlt />,
        cName: "sub-nav-text",
        roles: ["admin"]
      }
    ]
  },
  {
    title: "Audit & Logging",
    path: "/audit-logging",
    icon: <MdHistory />,
    cName: "nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Audit Log",
        path: "/audit-logging/audit-log",
        icon: <MdFactCheck />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "AI Processing Log",
        path: "/audit-logging/ai-processing-log",
        icon: <MdMemory />,
        cName: "sub-nav-text",
        roles: ["admin"]
      }
    ]
  },

  {
    title: "Spiritual Metrics",
    path: "/spiritual-metrics",
    icon: <GiMeditation />,
    cName: "nav-text",
    roles: ["Admin", "User"],
  },
  {
    title: "Avatar Tracker",
    path: "/avatar-tracker",
    icon: <LuCircle />,
    cName: "nav-text",
    roles: ["Admin", "User"],
  },
  {
    title: "AR Scanning",
    path: "/ar-scanning",
    icon: <TbAugmentedReality />,
    cName: "nav-text",
    roles: ["Admin", "User"],
  },
  {
    title: "Reports",
    path: "/reports",
    icon: <PiFileTextBold />,
    cName: "nav-text",
    roles: ["Admin"],
  },
  {
    title: "Preferences",
    path: "/preferences",
    icon: <FiSliders />,
    cName: "nav-text",
    roles: ["Admin", "User"],
  },
];
